import React from 'react';
import './title-screen-banner.css';
import classNames from 'classnames';
import MPText from '../../../assets/images/MP_Text.svg';
import UKParliament from '../../../assets/images/ukp-logo-primary.svg';

const TitleScreenBanner = props => {
    const { smallScreenStartExperience } = props;

    const titleBannerClasses = classNames({
        'title-screen-banner': true,
        'title-screen-banner--hidden': smallScreenStartExperience === true,
    });

    return (
        <div
            className={titleBannerClasses}
            aria-hidden={smallScreenStartExperience === true}
            role="banner"
        >
            <img
                src={UKParliament}
                alt="UK Parliament"
                className="title-screen-banner__uk-parliament"
            />
            <img
                src={MPText}
                alt="MP for a Week"
                className="title-screen-banner__mp-for-a-week"
            />
        </div>
    );
};

export { TitleScreenBanner };
